var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Node } from '../Node';
import { AnimationEngine } from '../animation/Animation';
import { pathContainsPoint, pathBounds } from '../utils/pathHitTest';
var Rect = /** @class */ (function (_super) {
    __extends(Rect, _super);
    function Rect(options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c;
        var _this = _super.call(this, 'rect', options) || this;
        _this.cornerRadius = 0;
        _this.width = (_a = options.width) !== null && _a !== void 0 ? _a : 100;
        _this.height = (_b = options.height) !== null && _b !== void 0 ? _b : 100;
        _this.cornerRadius = (_c = options.cornerRadius) !== null && _c !== void 0 ? _c : 0;
        return _this;
    }
    Rect.prototype.containsPoint = function (localX, localY) {
        return localX >= 0 && localY >= 0 && localX <= this.width && localY <= this.height;
    };
    Rect.prototype.getBounds = function () {
        return { x: 0, y: 0, width: this.width, height: this.height };
    };
    Rect.prototype.draw = function (ctx) {
        ctx.drawRect(this);
    };
    Rect.prototype.getShapeProps = function () {
        return { width: this.width, height: this.height, cornerRadius: this.cornerRadius };
    };
    return Rect;
}(Node));
export { Rect };
var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    function Circle(options) {
        if (options === void 0) { options = {}; }
        var _a;
        var _this = _super.call(this, 'circle', options) || this;
        _this.radius = (_a = options.radius) !== null && _a !== void 0 ? _a : 50;
        return _this;
    }
    Circle.prototype.containsPoint = function (localX, localY) {
        var dx = localX - this.radius;
        var dy = localY - this.radius;
        return dx * dx + dy * dy <= this.radius * this.radius;
    };
    Circle.prototype.getBounds = function () {
        return { x: 0, y: 0, width: this.radius * 2, height: this.radius * 2 };
    };
    Circle.prototype.draw = function (ctx) {
        ctx.drawCircle(this);
    };
    Circle.prototype.getShapeProps = function () {
        return { radius: this.radius };
    };
    return Circle;
}(Node));
export { Circle };
var Ellipse = /** @class */ (function (_super) {
    __extends(Ellipse, _super);
    function Ellipse(options) {
        if (options === void 0) { options = {}; }
        var _a, _b;
        var _this = _super.call(this, 'ellipse', options) || this;
        _this.radiusX = (_a = options.radiusX) !== null && _a !== void 0 ? _a : 50;
        _this.radiusY = (_b = options.radiusY) !== null && _b !== void 0 ? _b : 30;
        return _this;
    }
    Ellipse.prototype.containsPoint = function (localX, localY) {
        var dx = (localX - this.radiusX) / this.radiusX;
        var dy = (localY - this.radiusY) / this.radiusY;
        return dx * dx + dy * dy <= 1;
    };
    Ellipse.prototype.getBounds = function () {
        return { x: 0, y: 0, width: this.radiusX * 2, height: this.radiusY * 2 };
    };
    Ellipse.prototype.draw = function (ctx) {
        ctx.drawEllipse(this);
    };
    Ellipse.prototype.getShapeProps = function () {
        return { radiusX: this.radiusX, radiusY: this.radiusY };
    };
    return Ellipse;
}(Node));
export { Ellipse };
var Line = /** @class */ (function (_super) {
    __extends(Line, _super);
    function Line(options) {
        if (options === void 0) { options = {}; }
        var _a, _b;
        var _this = _super.call(this, 'line', options) || this;
        _this.x2 = (_a = options.x2) !== null && _a !== void 0 ? _a : 100;
        _this.y2 = (_b = options.y2) !== null && _b !== void 0 ? _b : 0;
        return _this;
    }
    Line.prototype.containsPoint = function (localX, localY) {
        var tolerance = Math.max(this.strokeWidth, 5);
        var dx = this.x2;
        var dy = this.y2;
        var lenSq = dx * dx + dy * dy;
        if (lenSq === 0)
            return Math.hypot(localX, localY) <= tolerance;
        var t = clamp((localX * dx + localY * dy) / lenSq, 0, 1);
        var px = t * dx;
        var py = t * dy;
        return Math.hypot(localX - px, localY - py) <= tolerance;
    };
    Line.prototype.getBounds = function () {
        return {
            x: Math.min(0, this.x2),
            y: Math.min(0, this.y2),
            width: Math.abs(this.x2),
            height: Math.abs(this.y2),
        };
    };
    Line.prototype.draw = function (ctx) {
        ctx.drawLine(this);
    };
    Line.prototype.getShapeProps = function () {
        return { x2: this.x2, y2: this.y2 };
    };
    return Line;
}(Node));
export { Line };
function clamp(v, min, max) {
    return v < min ? min : v > max ? max : v;
}
var Arc = /** @class */ (function (_super) {
    __extends(Arc, _super);
    function Arc(options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e;
        var _this = _super.call(this, 'arc', options) || this;
        _this.counterClockwise = false;
        _this.radius = (_a = options.radius) !== null && _a !== void 0 ? _a : 50;
        _this.innerRadius = (_b = options.innerRadius) !== null && _b !== void 0 ? _b : 0;
        _this.startAngle = (_c = options.startAngle) !== null && _c !== void 0 ? _c : 0;
        _this.endAngle = (_d = options.endAngle) !== null && _d !== void 0 ? _d : Math.PI * 1.5;
        _this.counterClockwise = (_e = options.counterClockwise) !== null && _e !== void 0 ? _e : false;
        return _this;
    }
    Arc.prototype.containsPoint = function (localX, localY) {
        var cx = this.radius;
        var cy = this.radius;
        var dx = localX - cx;
        var dy = localY - cy;
        var dist = Math.hypot(dx, dy);
        if (dist > this.radius || dist < this.innerRadius)
            return false;
        var angle = Math.atan2(dy, dx);
        var start = this.startAngle;
        var end = this.endAngle;
        if (this.counterClockwise) {
            if (start >= end)
                return angle <= start && angle >= end;
            return angle <= start || angle >= end;
        }
        if (end >= start)
            return angle >= start && angle <= end;
        return angle >= start || angle <= end;
    };
    Arc.prototype.getBounds = function () {
        return { x: 0, y: 0, width: this.radius * 2, height: this.radius * 2 };
    };
    Arc.prototype.draw = function (ctx) {
        ctx.drawArc(this);
    };
    Arc.prototype.getShapeProps = function () {
        return {
            radius: this.radius,
            innerRadius: this.innerRadius,
            startAngle: this.startAngle,
            endAngle: this.endAngle,
            counterClockwise: this.counterClockwise,
        };
    };
    return Arc;
}(Node));
export { Arc };
var Polygon = /** @class */ (function (_super) {
    __extends(Polygon, _super);
    function Polygon(options) {
        if (options === void 0) { options = {}; }
        var _a;
        var _this = _super.call(this, 'polygon', options) || this;
        _this.points = (_a = options.points) !== null && _a !== void 0 ? _a : [0, 0, 100, 0, 50, 80];
        return _this;
    }
    Polygon.prototype.containsPoint = function (localX, localY) {
        var pts = this.points;
        var inside = false;
        for (var i = 0, j = pts.length - 2; i < pts.length; j = i, i += 2) {
            var xi = pts[i], yi = pts[i + 1];
            var xj = pts[j], yj = pts[j + 1];
            if (yi > localY !== yj > localY && localX < ((xj - xi) * (localY - yi)) / (yj - yi) + xi) {
                inside = !inside;
            }
        }
        return inside;
    };
    Polygon.prototype.getBounds = function () {
        var minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
        for (var i = 0; i < this.points.length; i += 2) {
            minX = Math.min(minX, this.points[i]);
            minY = Math.min(minY, this.points[i + 1]);
            maxX = Math.max(maxX, this.points[i]);
            maxY = Math.max(maxY, this.points[i + 1]);
        }
        return { x: minX, y: minY, width: maxX - minX, height: maxY - minY };
    };
    Polygon.prototype.draw = function (ctx) {
        ctx.drawPolygon(this);
    };
    Polygon.prototype.getShapeProps = function () {
        return { points: __spreadArray([], __read(this.points), false) };
    };
    return Polygon;
}(Node));
export { Polygon };
var Polyline = /** @class */ (function (_super) {
    __extends(Polyline, _super);
    function Polyline(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, options) || this;
        _this.type = 'polyline';
        return _this;
    }
    Polyline.prototype.containsPoint = function (localX, localY) {
        var tolerance = Math.max(this.strokeWidth, 5);
        var pts = this.points;
        for (var i = 0; i < pts.length - 2; i += 2) {
            var x1 = pts[i], y1 = pts[i + 1];
            var x2 = pts[i + 2], y2 = pts[i + 3];
            var dx = x2 - x1, dy = y2 - y1;
            var lenSq = dx * dx + dy * dy;
            var t = lenSq === 0 ? 0 : clamp(((localX - x1) * dx + (localY - y1) * dy) / lenSq, 0, 1);
            var px = x1 + t * dx, py = y1 + t * dy;
            if (Math.hypot(localX - px, localY - py) <= tolerance)
                return true;
        }
        return false;
    };
    Polyline.prototype.draw = function (ctx) {
        ctx.drawPolyline(this);
    };
    return Polyline;
}(Polygon));
export { Polyline };
var Path = /** @class */ (function (_super) {
    __extends(Path, _super);
    function Path(options) {
        if (options === void 0) { options = {}; }
        var _a;
        var _this = _super.call(this, 'path', options) || this;
        _this.d = (_a = options.d) !== null && _a !== void 0 ? _a : 'M0 0 L100 100';
        return _this;
    }
    Path.prototype.containsPoint = function (localX, localY) {
        return pathContainsPoint(this.d, localX, localY, this.strokeWidth);
    };
    Path.prototype.getBounds = function () {
        return pathBounds(this.d);
    };
    Path.prototype.draw = function (ctx) {
        ctx.drawPath(this);
    };
    Path.prototype.getShapeProps = function () {
        return { d: this.d };
    };
    return Path;
}(Node));
export { Path };
var Star = /** @class */ (function (_super) {
    __extends(Star, _super);
    function Star(options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c;
        var _this = _super.call(this, 'star', options) || this;
        _this.numPoints = (_a = options.numPoints) !== null && _a !== void 0 ? _a : 5;
        _this.innerRadius = (_b = options.innerRadius) !== null && _b !== void 0 ? _b : 25;
        _this.outerRadius = (_c = options.outerRadius) !== null && _c !== void 0 ? _c : 50;
        return _this;
    }
    Star.prototype.containsPoint = function (localX, localY) {
        var cx = this.outerRadius;
        var cy = this.outerRadius;
        return Math.hypot(localX - cx, localY - cy) <= this.outerRadius;
    };
    Star.prototype.getBounds = function () {
        return { x: 0, y: 0, width: this.outerRadius * 2, height: this.outerRadius * 2 };
    };
    Star.prototype.draw = function (ctx) {
        ctx.drawStar(this);
    };
    Star.prototype.getShapeProps = function () {
        return {
            numPoints: this.numPoints,
            innerRadius: this.innerRadius,
            outerRadius: this.outerRadius,
        };
    };
    return Star;
}(Node));
export { Star };
var TextNode = /** @class */ (function (_super) {
    __extends(TextNode, _super);
    function TextNode(options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e, _f;
        var _this = _super.call(this, 'text', options) || this;
        _this.text = (_a = options.text) !== null && _a !== void 0 ? _a : '';
        _this.fontSize = (_b = options.fontSize) !== null && _b !== void 0 ? _b : 16;
        _this.fontFamily = (_c = options.fontFamily) !== null && _c !== void 0 ? _c : 'sans-serif';
        _this.fontWeight = (_d = options.fontWeight) !== null && _d !== void 0 ? _d : 'normal';
        _this.textAlign = (_e = options.textAlign) !== null && _e !== void 0 ? _e : 'left';
        _this.fill = (_f = options.fill) !== null && _f !== void 0 ? _f : '#000000';
        return _this;
    }
    TextNode.prototype.containsPoint = function (localX, localY) {
        var b = this.getBounds();
        return localX >= b.x && localY >= b.y && localX <= b.x + b.width && localY <= b.y + b.height;
    };
    TextNode.prototype.getBounds = function () {
        var w = this.text.length * this.fontSize * 0.6;
        return { x: 0, y: -this.fontSize, width: w, height: this.fontSize * 1.2 };
    };
    TextNode.prototype.draw = function (ctx) {
        ctx.drawText(this);
    };
    TextNode.prototype.getShapeProps = function () {
        return {
            text: this.text,
            fontSize: this.fontSize,
            fontFamily: this.fontFamily,
            fontWeight: this.fontWeight,
            textAlign: this.textAlign,
        };
    };
    return TextNode;
}(Node));
export { TextNode };
var ImageNode = /** @class */ (function (_super) {
    __extends(ImageNode, _super);
    function ImageNode(options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c;
        var _this = _super.call(this, 'image', options) || this;
        _this._image = null;
        _this.loaded = false;
        _this.src = (_a = options.src) !== null && _a !== void 0 ? _a : '';
        _this.width = (_b = options.width) !== null && _b !== void 0 ? _b : 100;
        _this.height = (_c = options.height) !== null && _c !== void 0 ? _c : 100;
        if (_this.src)
            _this.load();
        return _this;
    }
    ImageNode.prototype.load = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                _this._image = img;
                _this.loaded = true;
                _this.markDirty();
                resolve();
            };
            img.onerror = reject;
            img.src = _this.src;
        });
    };
    Object.defineProperty(ImageNode.prototype, "image", {
        get: function () {
            return this._image;
        },
        enumerable: false,
        configurable: true
    });
    ImageNode.prototype.containsPoint = function (localX, localY) {
        return localX >= 0 && localY >= 0 && localX <= this.width && localY <= this.height;
    };
    ImageNode.prototype.getBounds = function () {
        return { x: 0, y: 0, width: this.width, height: this.height };
    };
    ImageNode.prototype.draw = function (ctx) {
        ctx.drawImage(this);
    };
    ImageNode.prototype.getShapeProps = function () {
        return { src: this.src, width: this.width, height: this.height };
    };
    return ImageNode;
}(Node));
export { ImageNode };
var Sprite = /** @class */ (function (_super) {
    __extends(Sprite, _super);
    function Sprite(options) {
        if (options === void 0) { options = {}; }
        var _a, _b, _c, _d, _e;
        var _this = _super.call(this, options) || this;
        _this.currentFrame = 0;
        _this.playing = false;
        _this._lastTime = 0;
        _this._loop = true;
        _this._animControl = null;
        _this._frameProxy = { frame: 0 };
        _this.type = 'sprite';
        _this.frameWidth = (_a = options.frameWidth) !== null && _a !== void 0 ? _a : _this.width;
        _this.frameHeight = (_b = options.frameHeight) !== null && _b !== void 0 ? _b : _this.height;
        _this.frames = (_c = options.frames) !== null && _c !== void 0 ? _c : 1;
        _this.fps = (_d = options.fps) !== null && _d !== void 0 ? _d : 12;
        _this.playing = (_e = options.playing) !== null && _e !== void 0 ? _e : false;
        return _this;
    }
    Sprite.prototype.play = function (options) {
        var _this = this;
        if ((options === null || options === void 0 ? void 0 : options.fps) !== undefined)
            this.fps = options.fps;
        if ((options === null || options === void 0 ? void 0 : options.loop) !== undefined)
            this._loop = options.loop;
        this.stop();
        if (this.frames <= 1) {
            this.playing = true;
            return this;
        }
        this.playing = true;
        this.currentFrame = 0;
        this._frameProxy.frame = 0;
        var duration = ((this.frames - 1) / this.fps) * 1000;
        this._animControl = AnimationEngine.animate(this._frameProxy, {
            frame: this.frames - 1,
            duration: Math.max(duration, 1),
            loop: this._loop,
            onUpdate: function () {
                _this.currentFrame = Math.round(_this._frameProxy.frame);
                _this.markDirty();
            },
            onComplete: function () {
                if (!_this._loop)
                    _this.playing = false;
            },
        });
        this.markDirty();
        return this;
    };
    Sprite.prototype.stop = function () {
        var _a;
        this.playing = false;
        (_a = this._animControl) === null || _a === void 0 ? void 0 : _a.stop();
        this._animControl = null;
        return this;
    };
    Sprite.prototype.updateFrame = function (time) {
        if (this._animControl || !this.playing || this.frames <= 1)
            return;
        var interval = 1000 / this.fps;
        if (time - this._lastTime >= interval) {
            this.currentFrame = (this.currentFrame + 1) % this.frames;
            this._lastTime = time;
            this.markDirty();
        }
    };
    Sprite.prototype.draw = function (ctx) {
        ctx.drawSprite(this);
    };
    Sprite.prototype.getShapeProps = function () {
        return __assign(__assign({}, _super.prototype.getShapeProps.call(this)), { frameWidth: this.frameWidth, frameHeight: this.frameHeight, frames: this.frames, fps: this.fps });
    };
    return Sprite;
}(ImageNode));
export { Sprite };
/** Alias for rounded rectangle */
var RoundedRect = /** @class */ (function (_super) {
    __extends(RoundedRect, _super);
    function RoundedRect(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, __assign({ cornerRadius: 8 }, options)) || this;
        _this.type = 'roundedRect';
        return _this;
    }
    return RoundedRect;
}(Rect));
export { RoundedRect };
